const attending = [
  {
    "first_name": "Christine",
    "Initial": "Susan",
    "last_name": "Beck",
    "Nickname": "Beck",
    "other": "Frame",
    "School": "West"
  },
  {
    "first_name": "William",
    "Initial": "J.",
    "last_name": "Bernstein",
    "Nickname": "Bill",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Erwin",
    "Initial": "",
    "last_name": "Bieber",
    "Nickname": "Erwin",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Alice",
    "Initial": "",
    "last_name": "Bodley",
    "Nickname": "Alice",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Barbara",
    "Initial": "A.",
    "last_name": "Broughton",
    "Nickname": "Barb",
    "other": "Frank",
    "School": "West"
  },
  {
    "first_name": "Shirley",
    "Initial": "",
    "last_name": "Brown",
    "Nickname": "Shirley",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Barbara",
    "Initial": "",
    "last_name": "Brunner",
    "Nickname": "Barb",
    "other": "Skapura",
    "School": "West"
  },
  {
    "first_name": "Joseph",
    "Initial": "T.",
    "last_name": "Bucciarelli",
    "Nickname": "Bucc",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Margaret",
    "Initial": "",
    "last_name": "Cadwallaader",
    "Nickname": "Peggy",
    "other": "Vaihinger",
    "School": "West"
  },
  {
    "first_name": "Polly",
    "Initial": "",
    "last_name": "Case",
    "Nickname": "Polly",
    "other": "Glowatz",
    "School": "West"
  },
  {
    "first_name": "Robert",
    "Initial": "",
    "last_name": "Czerniak",
    "Nickname": "Bob",
    "other": "Czerniak",
    "School": "West"
  },
  {
    "first_name": "John",
    "Initial": "",
    "last_name": "Czerniakowski",
    "Nickname": "Cherny",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Jean",
    "Initial": "Louise",
    "last_name": "Davis",
    "Nickname": "Jean",
    "other": "Hoerr",
    "School": "West"
  },
  {
    "first_name": "Charles",
    "Initial": "",
    "last_name": "Driesbach",
    "Nickname": "Chuck",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Alfred",
    "Initial": "Carl",
    "last_name": "Erpel",
    "Nickname": "Al",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Patricia",
    "Initial": "Lois",
    "last_name": "Follett",
    "Nickname": "Patt",
    "other": "Kirkpatrick",
    "School": "West"
  },
  {
    "first_name": "Karen",
    "Initial": "Lee",
    "last_name": "Fretz",
    "Nickname": "Karen",
    "other": "Kofmehl",
    "School": "West"
  },
  {
    "first_name": "Joseph",
    "Initial": "E.",
    "last_name": "Fulcoly",
    "Nickname": "Jeff",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Duncan",
    "Initial": "H.",
    "last_name": "Grove",
    "Nickname": "Duncan",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Judith",
    "Initial": "I.",
    "last_name": "Gring",
    "Nickname": "Jude",
    "other": "Olson",
    "School": "West"
  },
  {
    "first_name": "Jennie",
    "Initial": "Lee",
    "last_name": "Harpster",
    "Nickname": "Lee",
    "other": "Basiago",
    "School": "West"
  },
  {
    "first_name": "Len",
    "Initial": "",
    "last_name": "Hause",
    "Nickname": "Len",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Norma",
    "Initial": "J.",
    "last_name": "Hinde",
    "Nickname": "Norma",
    "other": "Czerniak",
    "School": "West"
  },
  {
    "first_name": "Jay",
    "Initial": "",
    "last_name": "Hoffman",
    "Nickname": "Jay",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Arnold",
    "Initial": "L.",
    "last_name": "Horoff",
    "Nickname": "Arnie",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Ellen",
    "Initial": "Dent",
    "last_name": "Humphries",
    "Nickname": "Hump",
    "other": "Ponder",
    "School": "West"
  },
  {
    "first_name": "Carl",
    "Initial": "John",
    "last_name": "Husic",
    "Nickname": "Carl",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "William",
    "Initial": "J.",
    "last_name": "Ichter",
    "Nickname": "Jeffe",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "William",
    "Initial": "C.",
    "last_name": "Kienzle",
    "Nickname": "Bill",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Karen",
    "Initial": "Adele",
    "last_name": "Kot",
    "Nickname": "Karen",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Nancy",
    "Initial": "Carol",
    "last_name": "Lennox",
    "Nickname": "Nancy",
    "other": "McClendon",
    "School": "West"
  },
  {
    "first_name": "Betsy",
    "Initial": "",
    "last_name": "Macy",
    "Nickname": "Betsy",
    "other": "Patterson",
    "School": "West"
  },
  {
    "first_name": "Thomas",
    "Initial": "A.",
    "last_name": "Marett Jr.",
    "Nickname": "Tom",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Jim",
    "Initial": "",
    "last_name": "Maskas",
    "Nickname": "Jim",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Genevieve",
    "Initial": "Margaret",
    "last_name": "Matthews",
    "Nickname": "Genny",
    "other": "Greenhalgh",
    "School": "West"
  },
  {
    "first_name": "David",
    "Initial": "Richard",
    "last_name": "McClintock",
    "Nickname": "Bino",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Mary",
    "Initial": "",
    "last_name": "Laing",
    "Nickname": "",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Bill",
    "Initial": "G.",
    "last_name": "Means",
    "Nickname": "Bill",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Barbara",
    "Initial": "",
    "last_name": "Monaco",
    "Nickname": "Barb",
    "other": "Doughery",
    "School": "West"
  },
  {
    "first_name": "Joanne",
    "Initial": "",
    "last_name": "Murphy",
    "Nickname": "Joanne",
    "other": "Scotti",
    "School": "West"
  },
  {
    "first_name": "Diane",
    "Initial": "",
    "last_name": "Peters",
    "Nickname": "",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Michael",
    "Initial": "J.",
    "last_name": "Poserina",
    "Nickname": "Mike",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Ron",
    "Initial": "",
    "last_name": "Righter",
    "Nickname": "Ron",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Kurt",
    "Initial": "Gilbert",
    "last_name": "Rist",
    "Nickname": "Kurt",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "John",
    "Initial": "",
    "last_name": "Rubisch",
    "Nickname": "John",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "John",
    "Initial": "",
    "last_name": "Rubisch",
    "Nickname": "",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Gail",
    "Initial": "Marie",
    "last_name": "Simpson",
    "Nickname": "Gail",
    "other": "Watson",
    "School": "West"
  },
  {
    "first_name": "Richard",
    "Initial": "C.",
    "last_name": "Smith",
    "Nickname": "",
    "other": "",
    "School": "West"
  },  
  {
    "first_name": "Jeffrey",
    "Initial": "L.",
    "last_name": "Taylor",
    "Nickname": "Jeff",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Robert",
    "Initial": "",
    "last_name": "Upton",
    "Nickname": "Bob",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Margaret",
    "Initial": "Ann",
    "last_name": "Vaihinger",
    "Nickname": "Peggy",
    "other": "CadWallader",
    "School": "West"
  },
  {
    "first_name": "Marcella",
    "Initial": "",
    "last_name": "Walker",
    "Nickname": "Marcella",
    "other": "Shoeman",
    "School": "West"
  },
  {
    "first_name": "Jayne",
    "Initial": "Carol",
    "last_name": "Warrington",
    "Nickname": "Jayne",
    "other": "Ehrens",
    "School": "West"
  },
  {
    "first_name": "Bill",
    "Initial": "",
    "last_name": "Weir",
    "Nickname": "Bill",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Christian",
    "Initial": "",
    "last_name": "Wiggins",
    "Nickname": "Chris",
    "other": "",
    "School": "West"
  },
  {
    "first_name": "Sandra",
    "Initial": "",
    "last_name": "Wonsidler",
    "Nickname": "",
    "other": "Freeman",
    "School": "West"
  },
  {
    "first_name": "William",
    "Initial": "F.",
    "last_name": "Beck",
    "Nickname": "Bill",
    "other": "Beck",
    "School": "East"
  },
  {
    "first_name": "Virginia",
    "Initial": "",
    "last_name": "Betts",
    "Nickname": "Ginny",
    "other": "Souder",
    "School": "East"
  },
  {
    "first_name": "Blaine",
    "Initial": "",
    "last_name": "Brown",
    "Nickname": "Blaine",
    "other": "",
    "School": "East"
  },
  {
    "first_name": "Joan",
    "Initial": "",
    "last_name": "Chase",
    "Nickname": "Joan",
    "other": "States",
    "School": "East"
  },
  {
    "first_name": "Jay",
    "Initial": "Allen",
    "last_name": "Chaffee",
    "Nickname": "Jay",
    "other": "Chaffee",
    "School": "East"
  },
  {
    "first_name": "Anne",
    "Initial": "Ruth",
    "last_name": "Charles",
    "Nickname": "Ruth",
    "other": "Py",
    "School": "East"
  },
  {
    "first_name": "Kaythryn",
    "Initial": "Ann",
    "last_name": "Crouthamel",
    "Nickname": "Kay",
    "other": "Swartley",
    "School": "East"
  },
  {
    "first_name": "Susanne",
    "Initial": "J.",
    "last_name": "DeMoreland",
    "Nickname": "",
    "other": "Shuss",
    "School": "East"
  },
  {
    "first_name": "Patricia",
    "Initial": "R.",
    "last_name": "Demusz",
    "Nickname": "Pat",
    "other": "Mac Neel",
    "School": "East"
  },
  {
    "first_name": "Derek",
    "Initial": "",
    "last_name": "Foster",
    "Nickname": "Derek",
    "other": "Foster",
    "School": "East"
  },
  {
    "first_name": "Karen",
    "Initial": "K.",
    "last_name": "Gee",
    "Nickname": "Karen",
    "other": "Gee",
    "School": "East"
  },
  {
    "first_name": "Jo Anne",
    "Initial": "",
    "last_name": "Gemmell",
    "Nickname": "Jo Anne",
    "other": "Bucciarelli",
    "School": "East"
  },
  {
    "first_name": "Constance",
    "Initial": "Mary",
    "last_name": "Gibbons",
    "Nickname": "Connie",
    "other": "Gibbons",
    "School": "East"
  },
  {
    "first_name": "Craik",
    "Initial": "",
    "last_name": "Goodspeed",
    "Nickname": "Craik",
    "other": "",
    "School": "East"
  },
  {
    "first_name": "Karen",
    "Initial": "",
    "last_name": "Hare",
    "Nickname": "Karen",
    "other": "Ference",
    "School": "East"
  },
  {
    "first_name": "Mary",
    "Initial": "Joan",
    "last_name": "Harrington",
    "Nickname": "Joan",
    "other": "Kerber",
    "School": "East"
  },
  {
    "first_name": "Karen",
    "Initial": "Ann",
    "last_name": "Harris",
    "Nickname": "Karen",
    "other": "Harris",
    "School": "East"
  },
  {
    "first_name": "Pat",
    "Initial": "",
    "last_name": "Harstine",
    "Nickname": "Patti",
    "other": "Houston-Sellers",
    "School": "East"
  },
  {
    "first_name": "Margaret",
    "Initial": "",
    "last_name": "Kern",
    "Nickname": "Peggy",
    "other": "Lincoln",
    "School": "East"
  },
  {
    "first_name": "Lynn",
    "Initial": "M.",
    "last_name": "Kohl",
    "Nickname": "Lynn",
    "other": "Burkhart",
    "School": "East"
  },
  {
    "first_name": "Linda",
    "Initial": "E.",
    "last_name": "Krach",
    "Nickname": "Linda",
    "other": "Krach",
    "School": "East"
  },
  {
    "first_name": "Robert",
    "Initial": "Charles",
    "last_name": "Leayman",
    "Nickname": "Bob",
    "other": "Leayman",
    "School": "East"
  },
  {
    "first_name": "James",
    "Initial": "E.",
    "last_name": "Lehe",
    "Nickname": "Jim",
    "other": "Lehe",
    "School": "East"
  },
  {
    "first_name": "Dorothy",
    "Initial": "L",
    "last_name": "Lichtman",
    "Nickname": "Dottie",
    "other": "Macneel",
    "School": "East"
  },
  {
    "first_name": "John",
    "Initial": "",
    "last_name": "Liebendorfer",
    "Nickname": "John",
    "other": "",
    "School": "East"
  },
  {
    "first_name": "Joyce",
    "Initial": "",
    "last_name": "Palmer",
    "Nickname": "Joyce",
    "other": "Murphy",
    "School": "East"
  },
  {
    "first_name": "Lynn",
    "Initial": "",
    "last_name": "Pantuso",
    "Nickname": "Lynn",
    "other": "Pantuso",
    "School": "East"
  },
  {
    "first_name": "David",
    "Initial": "A.",
    "last_name": "Ponder",
    "Nickname": "Dave",
    "other": "Ponder",
    "School": "East"
  },
  {
    "first_name": "Kenneth",
    "Initial": "Franklin",
    "last_name": "Quire",
    "Nickname": "Ken",
    "other": "Quire",
    "School": "East"
  },
  {
    "first_name": "Cynthia",
    "Initial": "F.",
    "last_name": "Rozinski",
    "Nickname": "Cindy",
    "other": "Stine",
    "School": "East"
  },
  {
    "first_name": "Karen",
    "Initial": "Lee",
    "last_name": "Russel",
    "Nickname": "Karen",
    "other": "Hart",
    "School": "East"
  },
  {
    "first_name": "Francis",
    "Initial": "Paul",
    "last_name": "Russo",
    "Nickname": "Paul",
    "other": "Russo",
    "School": "East"
  },
  {
    "first_name": "Rebecca",
    "Initial": "",
    "last_name": "Rathgerber",
    "Nickname": "Becky",
    "other": "Schroeder",
    "School": "East"
  },
  {
    "first_name": "Alyce",
    "Initial": "Jeanne",
    "last_name": "Shriver",
    "Nickname": "Alyce",
    "other": "Fabian",
    "School": "East"
  },
  {
    "first_name": "Jeffrey",
    "Initial": "Edward",
    "last_name": "Silk",
    "Nickname": "Jeff",
    "other": "Silk",
    "School": "East"
  },
  {
    "first_name": "Monica",
    "Initial": "",
    "last_name": "Sinks",
    "Nickname": "Monica",
    "other": "Sinks",
    "School": "East"
  },
  {
    "first_name": "Jane",
    "Initial": "Smith.",
    "last_name": "Taylor",
    "Nickname": "Jane",
    "other": "",
    "School": "East"
  },
  {
    "first_name": "L.",
    "Initial": "Jeffrey",
    "last_name": "States",
    "Nickname": "Jeff",
    "other": "",
    "School": "East"
  },
  {
    "first_name": "Craig",
    "Initial": "Alan",
    "last_name": "Suber",
    "Nickname": "Craig",
    "other": "Suber",
    "School": "East"
  },
  {
    "first_name": "Mary",
    "Initial": "Ann",
    "last_name": "Vasil",
    "Nickname": "Mary Ann",
    "other": "Dwyer",
    "School": "East"
  },
  {
    "first_name": "Bertha",
    "Initial": "J.",
    "last_name": "Vaughn",
    "Nickname": "Bertha",
    "other": "Skerle",
    "School": "East"
  },
  {
    "first_name": "Brian",
    "Initial": "McClain",
    "last_name": "Vaughan",
    "Nickname": "Brian",
    "other": "Vaughn",
    "School": "East"
  },
  {
    "first_name": "Patricia",
    "Initial": "Ann",
    "last_name": "Waters",
    "Nickname": "Patti",
    "other": "Allen",
    "School": "East"
  },
  {
    "first_name": "Bonnie",
    "Initial": "L.",
    "last_name": "Weldon",
    "Nickname": "Bonnie",
    "other": "Callaghan",
    "School": "East"
  },
  {
    "first_name": "Jan",
    "Initial": "C.",
    "last_name": "Williams",
    "Nickname": "Jan",
    "other": "Ritter",
    "School": "East"
  },
  {
    "first_name": "Tousey",
    "Initial": "",
    "last_name": "Wilson",
    "Nickname": "Tousey",
    "other": "Wilson",
    "School": "East"
  },
  {
    "first_name": "Mercedes",
    "Initial": "V.",
    "last_name": "Worrall",
    "Nickname": "Meri",
    "other": "Hedrick",
    "School": "East"
  }
]

export default attending